import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "error.404.title",
    },
    p: {
        id: "error.404.p",
    },
});

export default messages;
